export default __webpack_public_path__ + "static/media/cell_2.1e073edf.png";